/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/ban-ts-ignore */

import '@/assets/styles/main.scss'
import Vue       from 'vue'
// @ts-ignore
import VueLayers from 'vuelayers'
// @ts-ignore
import UIkit     from "uikit";
// @ts-ignore
import Icons     from "uikit/dist/js/uikit-icons";

import {AxiosPlugin} from "./plugins/AxiosPlugin";

import store from "@/store";
import App   from './App.vue'


// @ts-ignore
UIkit.use(Icons);
export default (ctx: any, inject: any) => {
    ctx.$UIkit = UIkit;
    inject("UIkit", UIkit);
};


class Main {
    private instance: Vue | undefined;

    private init() {
        Vue.config.productionTip = false

        Vue.use(VueLayers)
        Vue.use(AxiosPlugin)

        this.instance = new Vue({
            store : store,
            render: h => h(App),
        }).$mount('#app')
    }

    constructor() {
        this.init();
    }
}

new Main();
